import { createUseStyles } from "react-jss";
const useStyles = createUseStyles(
  (theme) => ({
    popover: {},
    modalBody: {}
  }),
  { name: "ECPopover" }
);
export {
  useStyles as default
};
//# sourceMappingURL=PopoverStyles.js.map
